export const IDLE = "IDLE";
export const IN_PROGRESS = "IN_PROGRESS";
export const SUCCESS = "SUCCESS";
export const FAILED = "FAILED";
export const SUPER_ADMIN = "super-admin";
export const USER_MANAGER = "user-manager";
